import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";

import AccessTimeIcon from '@material-ui/icons/AccessTime';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import "./style.css";
import AdjustOutlinedIcon from "@material-ui/icons/AdjustOutlined";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

const lookup = [
  {
    value: 0,
    text: "деактивирована"
  },
  {
    value: 1,
    text: "активирована"
  },
  {
    value: 2,
    text: "не активирована"
  }
];

function personRegStatusCell(config) {
  config.cellRender = PersonStateCell;
  config.dataType = "number";
  config.alignment = "center";
  config.lookup = {
    dataSource: lookup,
    valueExpr: "value",
    displayExpr: "text"
  }
}

const personStateTextColor = {
  '0': "#F15454",
  '2': "#007FBD",
  '1': "#85C446",
  'DEACTIVATED': "#F15454",
  'NOT_ACTIVE': "#007FBD",
  'ACTIVE': "#85C446"
};

const PersonStateCell = (cellData) => {
  switch (cellData.value) {
    case 0:
    case 'DEACTIVATED':
      return (
        <div>
          <Tooltip title="Учетная запись деактивирована">
            <Chip color="primary"
                  style={{ "background": personStateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<BlockIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 1:
    case 'ACTIVE':
      return (
        <div>
          <Tooltip title="Учетная запись активирована">
            <Chip color="primary"
                  style={{ "background": personStateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<CheckCircleOutlineIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 2:
    case 'NOT_ACTIVE':
      return (
        <div>
          <Tooltip title="Учетная запись не активирована">
            <Chip color="primary"
                  style={{ "background": personStateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<AccessTimeIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    default:
      return (
        <div>
          <Tooltip title="Статус не указан">
            <Chip color="primary"
                  style={{ "background": "#000000"}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<HelpOutlineIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      )
  }
};

export {personRegStatusCell};
